@if (shippingModeList) {
  <div class="tw-shipping-mode-list tw-padding-10">
    <!--    <div class="tw-padding-10"> <strong style="font-size: 20px;margin-left: -11px">{{'shipping.shipping' | translate}} </strong></div>-->
    @for (sh of shippingModeList; track sh; let i = $index) {
        <div class="tw-shipping-mode-list-item tw-shipping-mode-list-item-temp" style="margin: 13px 0;
    padding: 5px;
    border-radius: 9px;">
        @if (shippingModeList.length >1) {
          <div class="tw-flex tw-row tw-header-show temp-shipping-mode-selected" style="background:snow">
            <div style="text-align: center;width: 80px">
              @if (sh.event && sh.event.images && sh.event.images.length>0) {
                <img
                  [src]="sh.event.images[0].url | twUrl "
                  style="max-height: 80px;max-width: 80px ; background: blue">
              }
              <div style="font-size: 22px; margin-top: -53px; margin-left: 47px; height: 48px; color:green;">
                <!--                        <span class="tw-header-number">{{getTickets()}}</span>-->
              </div>
            </div>
            <div class="tw-header-font">
              @if (sh.event.title) {
                <div style="font-weight: 600">
                  {{sh.event.title}}
                </div>
              }
              <!--                    <div style="font-weight: 600" *ngIf='sh.event.location.name'>-->
              <!--                        {{sh.event.location.name}}-->
            <!--                    </div>-->
            @if (sh.event.eventStart) {
              <div>
                {{sh.event.eventStart}}
              </div>
            }
          </div>
        </div>
      }
            <tw-shipping-mode [data]="{
            territory:territory,shippingMode:sh
            }"
      [shippingMode]="sh"></tw-shipping-mode>
      <!--            <hr *ngIf="shippingModeList.length && i < shippingModeList.length-1">   -->
    </div>
    <!--        {{sh | json}}-->
  }
</div>
}
